export default theme => ({
  dialog__windowed: {
    maxWidth: "fit-content"
  },
  dialog_closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.primary.main,
  },
  dialog__title: {
    width: "90%",
  },
});
